import { bulletTypes } from "~defs/BulletTypeDefs";
import { Bullet } from "./Bullet";
import { BulletController } from "./BulletController";
import { Engine } from "./Engine";

export class BulletType {
  id: string;
  name: string;
  damage: number;
  cooldown: number;
  explosionDamageSize: number;
  explosionTerrainSize: number;
  angleVariance: number;
  powerVariance: number;
  powerMultiplier: number;
  spawnHook: (self: Bullet, engine: Engine) => void;
  explodeHook: (self: Bullet, engine: Engine) => void;
  tickHook: (self: Bullet, engine: Engine) => void;

  constructor(opts: {
    id: string;
    name: string;
    damage: number;
    cooldown: number;
    explosionDamageSize: number;
    explosionTerrainSize: number;
    angleVariance?: number;
    powerVariance?: number;
    powerMultiplier?: number;
    spawnHook?: (self: Bullet, engine: Engine) => void;
    explodeHook?: (self: Bullet, engine: Engine) => void;
    tickHook?: (self: Bullet, engine: Engine) => void;
  }) {
    const {
      id,
      name,
      damage,
      cooldown,
      explosionDamageSize,
      explosionTerrainSize,
      angleVariance,
      powerVariance,
      powerMultiplier,
      spawnHook,
      explodeHook,
      tickHook,
    } = opts;
    this.id = id;
    this.name = name;
    this.damage = damage;
    this.cooldown = cooldown;
    this.explosionDamageSize = explosionDamageSize;
    this.explosionTerrainSize = explosionTerrainSize;
    this.angleVariance = angleVariance ?? 0.01;
    this.powerVariance = powerVariance ?? 0.05;
    this.powerMultiplier = powerMultiplier ?? 1;
    this.spawnHook = spawnHook ?? (() => {});
    this.explodeHook = explodeHook ?? (() => {});
    this.tickHook = tickHook ?? (() => {});
  }
}

export function flak(
  self: Bullet,
  bulletController: BulletController,
  args: {
    count: number;
    type: string;
    vxVariance?: number;
    vyVariance?: number;
    disableSpawnHook?: boolean;
  }
) {
  let { count, type, vxVariance, vyVariance, disableSpawnHook } = args;
  vxVariance ??= 0.5;
  vyVariance ??= 0.5;
  if (disableSpawnHook === undefined) disableSpawnHook = true;

  Array.from({ length: count }).forEach(() =>
    bulletController.spawnBullet({
      x: self.x,
      y: self.y,
      vx: self.vx + Math.random() * vxVariance * 2 - vxVariance,
      vy: self.vy + Math.random() * vyVariance * 2 - vyVariance,
      type: bulletTypes[type],
      owner: self.owner,
      parentType: self.parentType,
      disableSpawnHook: disableSpawnHook,
    })
  );
}

export function frag(
  self: Bullet,
  bulletController: BulletController,
  args: {
    count: number;
    type: string;
    powerRange?: number;
    powerBase?: number;
    angleRange?: number;
    angleBase?: number;
    disableSpawnHook?: boolean;
  }
) {
  let {
    count,
    type,
    powerRange,
    powerBase,
    angleRange,
    angleBase,
    disableSpawnHook,
  } = args;
  powerBase ??= 2.4;
  powerRange ??= 0.4;
  angleRange ??= Math.PI;
  angleBase ??= -Math.PI / 2;
  if (disableSpawnHook === undefined) disableSpawnHook = true;

  Array.from({ length: count }).forEach(() => {
    const power = powerBase + Math.random() * powerRange * 2 - powerRange;
    const angle = angleBase + Math.random() * angleRange * 2 - angleRange;
    bulletController.spawnBullet({
      x: self.x,
      y: self.y,
      vx: Math.cos(angle) * power,
      vy: Math.sin(angle) * power,
      type: bulletTypes[type],
      owner: self.owner,
      parentType: self.parentType,
      disableSpawnHook: disableSpawnHook,
    });
  });
}
